
export default class   DashboardResponse {
    constructor(
    public response?: CostumResponse  ,
    public velocimetro?: Velocimetro  ,
    public dashboard?: Dashboard  ,
    public detalleCuenta?: DetalleCuenta ,
    public respCode? : number
    ){}
}
export interface DashboardEntity {
    userIdentity: string;
    velocimetro: Velocimetro;
    dashboard: Dashboard;
    detalleCuenta: DetalleCuenta;
  }

class   Dashboard {
    constructor(
    public saludo?: string,
    public indMostrarVideo?:number,
    public fechaBalance?: string,
    public balanceMonto?: number,
    public moneda?: string,
    public nss?: number,
    public codigoCuenta?: string,
    public rentabilidadFondo?: number,
    public distribucionBalance?: DistribucionBalance,
    public distribucionBalanceMonto?: DistribucionBalance,
    ){}
}

class   DetalleCuenta {
    constructor(
        public fechaAfiliacion?: string,
        public montoUltimoAporte?: number,
        public fechaUltimoAporte?: string,
        public ultimoEmpleador?: string,
        public fechaPrimerAporte?: string,
        public fechaAfiliacionSistema?: string,
        public estadoCuenta?: string,
        public salarioUltimoAporte?: number,
    ){}
}

class   DistribucionBalance {
    constructor(
        public aporteEmpleado?: number,
        public aporteEmpleador?: number,
        public rentabilidad?: number,
        public otrosAportes?:number,
        public otrosAportesDetalle?: OtrosAportesDetalle[]
    ){}
}

class   OtrosAportesDetalle {
    constructor(
        public nombreAporteDetalle?: string,
        public montoAporteDetalle?: number
    ){
    }
}

class   CostumResponse {
    constructor(
        public success?: boolean,
        public message?: string,
        public respCode?: number
    ){}
}

class   Root {
    constructor(
        public response?: Response,
        public velocimetro?: Velocimetro,
        public dashboard?: Dashboard,
        public detalleCuenta?: DetalleCuenta
        ){}
}

class   Velocimetro {
    constructor(
        public cantidadCotizaciones?: number,
        public cantidadMesesAfiliado?: number,
        public calculoDensidad?: number){}
}
export{DashboardResponse,Velocimetro,Root,CostumResponse,OtrosAportesDetalle,DistribucionBalance,DetalleCuenta,Dashboard}